<div *ngIf="perfilAmplo">
    <br />
    <p class="text-justify">
        CONTRATO DE PRESTAÇÃO DE SERVIÇOS - CONECTIVIDADE SOCIAL<br />
        CAIXA X CLIENTE PESSOA JURÍDICA - PERFIL {{infoContratos.tipoContrato}}
    </p>
    <br />
    <p class="text-justify">
        Pelo presente instrumento, a CAIXA ECONÔMICA FEDERAL, com sede no Setor Bancário Sul, Quadra 4, Lotes 3 e 4 -
        CEP
        70092 - 900, Brasília - DF, CNPJ 00360305/0001-04, doravante denominada CAIXA, e, de outro lado,
        a empresa {{infoContratos.razaoSocial}}, com inscrição CNPJ/CEI n.º {{ inscricaoFormatada }}, doravante
        denominada CLIENTE, ajustam e celebram este contrato para os fins e sob as condições adiante indicadas.
    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 1ª - DO OBJETO
        O presente contrato tem por objeto possibilitar ao CLIENTE o acesso remoto, por meio de computador próprio, aos
        serviços disponíveis para o Perfil Pessoa Jurídica {{infoContratos.tipoContrato}} no CONETIVIDADE SOCIAL.

    </p>
    <br />
    <p class="text-justify">
        <strong>Perfil:</strong> {{infoContratos.desPerfil}}

    </p>
    <br />

    <strong>Serviços Disponíveis:</strong>

    <ul>
        <li *ngFor="let servico of infoContratos.servicos">{{servico}}</li>
    </ul>

    <br />
    <p class="text-justify">

        CLÁUSULA 2ª - DAS DEFINIÇÕES

        Para efeito deste contrato, considera-se:
        I - CONECTIVIDADE SOCIAL - Aplicativo que, através de acesso remoto, via Internet, disponibiliza serviços e
        informações ao CLIENTE. Marca registrada da CAIXA que identifica o conjunto de serviços e informações
        disponíveis
        através de conexão segura com o seu ambiente computacional. Ferramenta tecnológica associada à Internet que
        viabiliza a troca segura de informações entre as Instituições Financeiras;


        II - CONEXÃO - Forma de comunicação entre os computadores do CLIENTE e o ambiente computacional do CONECTIVIDADE
        SOCIAL;

        III - Internet - Rede de computadores interligados em todo o mundo, que se utiliza de um mesmo protocolo
        (TCP/IP) e
        de serviços de forma a permitir que os computadores instalados em diversas regiões geográficas possam entrar em
        contato uns com os outros e trocar informações;

        IV - PROTOCOLO TCP/IP - (Transmission Control Protocol / Internetworking Protocol) - Protocolo de comunicação
        básico
        da Internet para interconectar redes cujos componentes podem usar sistemas operacionais distintos;

        V - PROVEDOR - Máquinas Servidoras que possibilitam, às máquinas clientes, o acesso à rede Internet;

        VI - SENHA - código secreto que possibilita o acesso ao aplicativo disponibilizado. É pessoal e intransferível,
        razão pela qual a CAIXA não se responsabiliza pelo seu uso indevido;

        VII - ASSINATURA ELETRÔNICA - é o mecanismo apto a permitir e legitimar a autorização de acesso ao serviço
        requerido; sempre combinada com a senha.

        VIII - CERTIFICADO DIGITAL - Identificação eletrônica mediante o uso de chave pública e privada, utilizada para
        atestar a identidade dos atores envolvidos na conexão;

        IX - Ambiente Computacional do CONECTIVIDADE SOCIAL - Computadores de pequeno e grande porte onde estão contidos
        os
        dados e as informações referentes aos produtos e serviços oferecidos pela CAIXA;

        X - EMPRESA RAIZ - Pessoa Jurídica que se encontra no primeiro nível na cadeia de procurações, sendo detentora
        originária dos poderes relacionados ao seu perfil registrado no CONECTVIDADE SOCIAL.

        XI - PODER - Serviço disponibilizado no CONECTVIDADE SOCIAL, que pode ser utilizado pela EMPRESA RAIZ ou
        repassado
        por ela a terceiros.

        XII - CADEIA HORIZONTAL - cadeia de procurações que se encontram no mesmo nível de outorga ou substabelecimento.

        XIII - CADEIA VERTICAL - cadeia de procurações concedidas a Pessoas Jurídicas ou Físicas, que se encontram em
        diferentes níveis de outorga ou substabelecimento, cujas validades são condicionadas à validade das procurações
        precedentes.

        XIV - OUTORGANTE - Pessoa Jurídica ou Física que transfere seus poderes a outrem, no todo ou em parte, com ou
        sem
        prerrogativa de substabelecimento, por meio de Procuração Eletrônica do CONECTIVIDADE SOCIAL.

        XV - OUTORGADO - Pessoa Jurídica ou Física que representa o Outorgante através de Procuração Eletrônica do
        CONECTIVIDADE SOCIAL.

        XVI - SUBSTABELECEDOR - Pessoa Jurídica ou Física que, tendo recebido poderes através de Procuração Eletrônica
        do
        CONECTIVIDADE SOCIAL com prerrogativa de substabelecimento, os transfere a outrem.

        XVII - SUBSTABELECIDO - Pessoa Jurídica ou Física que recebe poderes de um substabelecedor por meio de
        Procuração
        Eletrônica do CONECTIVIDADE SOCIAL.

        XVIII - SÍTIO - é um conjunto de páginas acessíveis através de um endereço na Internet.

        IXX - Firewall - é o nome dado ao dispositivo de rede de computadores que tem por objetivo aplicar uma política
        de
        segurança com o objetivo de evitar acessos nocivos ou não autorizados.
    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 3ª - DA UTILIZAÇÃO

        O CLIENTE deverá dispor de certificado digital válido, gerado no padrão ICP-Brasil por Autoridade Certificadora
        - AC
        credenciada pelo Instituto Brasileiro de Tecnologia da Informação - ITI, e da respectiva senha, de caráter
        sigiloso,
        pessoal e intransferível.


        § 1º - Quaisquer irregularidades verificadas quando da operacionalização do CONECTIVIDADE SOCIAL deverão ser
        comunicadas à CAIXA e, se for o caso, o CLIENTE deverá solicitar imediatamente a suspensão do serviço.

        § 2º - A CAIXA poderá, a qualquer tempo, suspender e cancelar o acesso ao CONECTIVIDADE SOCIAL, caso verifique,
        através dos seus sistemas de segurança, que as operações realizadas pelo CLIENTE estão ou possam vir a estar
        comprometidas pelo uso de programas adulterados ou maliciosos que ameacem a integridade, a confidencialidade ou
        a
        disponibilidade das informações contidas no sítio do CONECTIVIDADE SOCIAL, comunicando, posteriormente, ao
        CLIENTE.
    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 3ª - DA UTILIZAÇÃO

        O CLIENTE deverá dispor de certificado digital válido, gerado no padrão ICP-Brasil por Autoridade Certificadora
        - AC
        credenciada pelo Instituto Brasileiro de Tecnologia da Informação - ITI, e da respectiva senha, de caráter
        sigiloso,
        pessoal e intransferível.


        § 1º - Quaisquer irregularidades verificadas quando da operacionalização do CONECTIVIDADE SOCIAL deverão ser
        comunicadas à CAIXA e, se for o caso, o CLIENTE deverá solicitar imediatamente a suspensão do serviço.

        § 2º - A CAIXA poderá, a qualquer tempo, suspender e cancelar o acesso ao CONECTIVIDADE SOCIAL, caso verifique,
        através dos seus sistemas de segurança, que as operações realizadas pelo CLIENTE estão ou possam vir a estar
        comprometidas pelo uso de programas adulterados ou maliciosos que ameacem a integridade, a confidencialidade ou
        a
        disponibilidade das informações contidas no sítio do CONECTIVIDADE SOCIAL, comunicando, posteriormente, ao
        CLIENTE.


    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 4ª - DAS OBRIGAÇÕES DA CAIXA

        A CAIXA se obriga a:

        I - disponibilizar acesso aos serviços disponíveis no CONECTIVIDADE SOCIAL, a qualquer tempo, no ambiente do
        próprio
        cliente;

        II - prestar as informações necessárias ao CLIENTE sobre os procedimentos de instalação e configuração dos
        aplicativos
        disponibilizados;

        III - manter Central de Atendimento à disposição do CLIENTE, nos dias e horários definidos pela CAIXA, para
        consultas
        sobre questões técnicas relativas à instalação, configuração, navegação e acesso ao CONECTIVIDADE SOCIAL;

        IV - processar ou encaminhar para processamento junto à instituição destinatária as informações recebidas do
        CLIENTE
        pelo CONETIVIDADE SOCIAL, desde que estas estejam consistidas e atendam aos requisitos de segurança ou quaisquer
        outros
        que venham a ser definidos pela CAIXA.

        V - assumir eventuais danos e/ou prejuízos causados por seus empregados e/ou prepostos no caso destes divulgarem
        ou
        utilizarem indevidamente dados ou informações a que tiverem acesso em virtude do presente contrato.

    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 5ª - DAS OBRIGAÇÕES DO CLIENTE

        O CLIENTE se obriga a:

        I - arcar com quaisquer despesas decorrentes dos serviços de telecomunicações, inclusive provedores de acesso à
        Internet, utilizados para conexão com o ambiente computacional do CONECTIVIDADE SOCIAL;

        II - fazer uso adequado da faculdade de outorga ou substabelecimento de Procuração Eletrônica, a que alude a
        CLÁUSULA 9ª deste contrato;

        III - guardar sigilo de sua senha, solicitando ou providenciando sua troca sempre que julgar necessário, bem
        como
        manter em lugar seguro seu Certificado Digital;

        IV - comunicar à CAIXA qualquer indício de irregularidade ou anormalidade apurada na utilização do CONECTIVIDADE
        SOCIAL;

        V - dispor, por seus próprios meios e iniciativas, de equipamentos e programas computacionais, além de todos os
        instrumentos necessários, compatíveis com a solução tecnológica do CONETIVIDADE SOCIAL e suas atualizações, que
        possibilitem a sua participação nas consultas aos dados e acesso aos serviços do CONECTIVIDADE SOCIAL;

        VI - assumir eventuais danos ou prejuízos causados à CAIXA ou a terceiros pelo uso indevido do CONETIVIDADE
        SOCIAL
        ou pela divulgação ou utilização indevida das informações a que este ou seus procuradores tiverem acesso em
        virtude
        do presente contrato;

        VII - responsabilizar-se integralmente pelos atos por ele praticados e solidariamente pelos executados por seus
        outorgados e substabelecidos;

        VIII - utilizar antivírus, firewall e demais programas sempre com versões atualizadas e registradas de acordo
        com a
        legislação vigente.

    </p>
    <br />

    <p class="text-justify">

        CLÁUSULA 6ª - DAS RESPONSABILIDADES DO CLIENTE

        É de inteira responsabilidade do CLIENTE toda e qualquer informação prestada no uso dos serviços disponíveis no
        CONECTIVIDADE SOCIAL, mediante a utilização de seu Certificado Digital e Senha.

        § 1º - Fornecer informações corretas e atualizadas, as quais, após atestada a autenticidade e consistência do
        Certificado Digital e senha utilizados, serão, para todos os efeitos legais, consideradas como prestadas pelo
        CLIENTE.

        § 2º - Usar adequadamente os serviços do CONECTIVIDADE SOCIAL. Comprovada sua utilização para fins ilícitos ou
        inadequados, sujeitar-se-á o CLIENTE às penalidades civis e penais cabíveis e à imediata suspensão ou revogação
        dos
        serviços.

        § 3º - Assumir inteira responsabilidade pela criação, extinção ou alteração de direitos ou deveres que venham a
        ocorrer em razão de informações incorretas, falsas, incompletas, adulteradas ou inconsistentes que sejam
        prestadas
        por ele, por seus outorgados ou por seus substabelecidos no CONECTIVIDADE SOCIAL, perante a CAIXA ou quaisquer
        outras entidades da Administração Pública direta ou indireta, ou ainda perante particulares que venham a ser
        prejudicados.

    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 7ª - DO DIREITO DE PROPRIEDADE


        A marca CONECTIVIDADE SOCIAL, o aplicativo, o sítio do CONECTIVIDADE SOCIAL e as imagens associadas à respectiva
        solução tecnológica são de propriedade da CAIXA ECONÔMICA FEDERAL, sendo vedado ao CLIENTE, nos termos da
        legislação
        em vigor, por qualquer forma, utiliza-los para obter lucros ou benefícios, para si ou para outrem, decorrentes
        do
        direito de uso objeto deste contrato.

    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 8ª - DAS ATUALIZAÇÕES E MODIFICAÇÕES

        A CAIXA, poderá agregar, retirar ou alterar os serviços e as formas de acesso ao CONECTIVIDADE SOCIAL, além de
        promover, a qualquer tempo, atualizações no aplicativo por meio de novas versões.

    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 9ª - DA UTILIZAÇÃO DO CONECTIVIDADE SOCIAL POR TERCEIROS

        O CLIENTE poderá, mediante substabelecimento de Procuração Eletrônica, repassar a terceiros os poderes
        eventualmente
        recebidos por outorga ou substabelecimento, se assim dispôs previamente o outorgante ou substabelecedor,
        observadas
        as regras de utilização desta prerrogativa definidas pela CAIXA.

        § 1º - A Procuração Eletrônica conferida pelo CLIENTE a um terceiro gera efeitos exclusivamente no âmbito do
        CONECTIVIDADE SOCIAL, podendo, todavia, ser aceita para outros processos que sejam disponibilizados pela CAIXA
        ou
        por outras entidades da Administração Pública direta ou indireta, exclusivamente em rotinas relacionadas às
        obrigações do CLIENTE junto a essas entidades e às informações transitadas pelo Conectividade Social.

        § 2º - As Procurações Eletrônicas têm validade de 12 meses a partir da data de emissão, devendo ser renovadas
        antes
        do seu vencimento a fim de não comprometer a continuidade dos serviços disponibilizados ao CLIENTE e a seus
        substabelecidos.

        § 3º - A validade da Procuração Eletrônica não está vinculada à validade do Certificado Digital, mas à validade
        das
        procurações na cadeia vertical superior e à validade do registro do CLIENTE e dos demais membros da cadeia de
        procurações no CONECTIVIDADE SOCIAL.

        § 4º - O CLIENTE somente poderá conceder Procuração Eletrônica a Pessoa Física que mantenha, com o mesmo
        empregador,
        espécie de vínculo empregatício passível de ser atestada pela CAIXA, por meio de seu próprio cadastro ou de
        outras
        informações que esta venha, a seu critério, entender mais adequadas.

        § 5º - No momento do substabelecimento de uma Procuração Eletrônica, o CLIENTE transfere um conjunto de poderes
        recebidos do outorgante ou substabelecedor a um terceiro, para este transacionar em nome do outorgante no
        CONECTIVIDADE SOCIAL, podendo conferir ao substabelecido o direito de substabelecer os poderes recebidos.

        § 6º - O CLIENTE ou seus procuradores Pessoa Física, estes desde que autorizados, poderão conceder Procuração
        Eletrônica a Pessoas Jurídicas; porém, estas não poderão repassar os poderes recebidos a outras Pessoas
        Jurídicas,
        ainda que o CLIENTE ou seus procuradores Pessoas Físicas tenham conferido ao substabelecido o direito de
        substabelecimento.

        § 7º - As transações efetuadas por um terceiro que tenha recebido uma Procuração Eletrônica do CLIENTE ou de seu
        procurador, quando este for autorizado a substabelecer poderes, gerarão os mesmos efeitos das transações
        efetuadas
        pelo próprio CLIENTE, recaindo sobre este a responsabilidade por tais transações, nos termos da CLÁUSULA 6ª e
        demais
        disposições deste contrato.

        § 8º - As procurações eletrônicas não poderão, em hipótese alguma, ser substabelecidas além do 5º nível
        vertical.

        § 9º - Cabe exclusivamente ao CLIENTE o controle do uso das procurações eletrônicas por ele ou por seus
        procuradores
        conferidas, podendo revogá-las a seu próprio critério e a qualquer tempo.

        § 10º - Ocorrendo a revogação ou expiração de uma Procuração Eletrônica, todos os substabelecimentos vinculados
        a
        esta procuração, na cadeia vertical inferior, serão igualmente revogados ou expirados pelo sistema.

        § 11º - Ocorrendo a revogação ou suspensão do Registro do CLIENTE, todas as outorgas e os substabelecimentos
        concedidos serão igualmente revogados pelo sistema.

        § 12º - A CAIXA poderá revogar, de ofício, qualquer Procuração Eletrônica que venha a ser considerada irregular
        ou
        potencialmente lesiva ao CLIENTE, aos demais usuários do CONECTIVIDADE SOCIAL ou a quaisquer entidades da
        Administração Pública Direta ou Indireta, ou ainda que venha a estar em discordância com as normas e regras
        estabelecidas pela CAIXA, mesmo que em razão de fatos ou circunstâncias supervenientes à sua outorga ou
        substabelecimento.

        § 13º - As procurações eletrônicas podem, ainda, ser aditadas a qualquer tempo, acrescentando-se a elas novos
        poderes, porém esta ação não confere novo prazo de validade a tais procurações.

    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 10ª - DO PRAZO DE DURAÇÃO

        As presentes disposições vigorarão a partir da data da aceitação pelo CLIENTE deste Instrumento de Contrato, por
        prazo indeterminado, até que seja denunciado ou revogado por uma das partes.

    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 11ª - DA DENÚNCIA
        Será facultada às partes a denúncia do presente contrato, a qualquer tempo, mediante comunicação formal.

        § 1º - Constituirá causa de denúncia, independente de aviso ou interpelação, judicial ou extrajudicial,
        respondendo
        a parte que der causa à rescisão, pelos prejuízos causados à outra:

        I - o descumprimento de quaisquer das cláusulas contratuais;

        II - a prática dolosa de qualquer ação ou deliberada omissão do CLIENTE visando a obtenção de vantagens ilícitas
        por
        meio do CONECTIVIDADE SOCIAL.

    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 12ª - DO PREÇO DA PRESTAÇÃO DOS SERVIÇOS
        Por liberalidade da CAIXA, não serão cobradas tarifas ao CLIENTE ou a seus procuradores pela prestação dos
        serviços
        que forem objeto do presente contrato.


        § 1º - A CAIXA pode a qualquer tempo vir a revogar tal liberalidade de isenção, passando a cobrar tarifa pela
        utilização de parte ou da totalidade dos serviços disponibilizados no CONECTIVIDADE SOCIAL, caso em que o
        CLIENTE
        será notificado, por meio de sua caixa postal no próprio CONECTIVIDADE SOCIAL, com antecedência mínima de 60
        (sessenta) dias. Na mesma notificação, constarão os valores das tarifas eventualmente cobradas por serviço ou
        conjunto de serviços, a forma de apuração e de cobrança.

    </p>
    <br />
    <p class="text-justify">


        CLÁUSULA 13ª - DAS DISPOSIÇÕES GERAIS
        O CLIENTE, após manifestar o aceite aos termos e condições deste contrato, terá acesso às orientações acerca dos
        procedimentos para a utilização da solução tecnológica do CONECTIVIDADE SOCIAL.

    </p>
    <br />
    <p class="text-justify">

        CLÁUSULA 14ª - DO FORO

        Para dirimir quaisquer questões decorrentes deste instrumento, as partes elegem, com privilégio sobre qualquer
        outro, o foro da Seção Judiciária da Justiça Federal do Distrito Federal - DF.
    </p>
    <br />
</div>
<div *ngIf="perfilRestrito">
    <br />
    <p class="text-justify">
        <strong>Conectividade <br /></strong>
        Contrato: 21234973 <br />
        TERMO DE ACEITE DO CONTRATO
    </p>
    <br />
    <p class="text-justify">
        CONTRATO DE PRESTAÇÃO DE SERVIÇOS - CONECTIVIDADE SOCIAL<br />
        CAIXA X CLIENTE PESSOA JURÍDICA - PERFIL {{infoContratos.tipoContrato}}
    </p>
    <br />
    <p class="text-justify">
        Pelo presente instrumento, a CAIXA ECONÔMICA FEDERAL, com sede no Setor Bancário Sul, Quadra 4, Lotes 3 e 4 -
        CEP 70092 - 900, Brasília - DF, CNPJ 00360305/0001-04, doravante denominada CAIXA, e, de outro lado,
        a empresa {{infoContratos.razaoSocial}}, com inscrição CNPJ/CEI n.º {{ inscricaoFormatada }}, doravante
        denominada CLIENTE, ajustam e celebram este contrato para os fins e sob as condições adiante indicadas.

    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 1ª - DO OBJETO</strong><br /><br />
        O presente contrato tem por objeto possibilitar ao CLIENTE o acesso remoto, por meio de computador próprio, aos
        serviços disponíveis para o Perfil Pessoa Jurídica {{infoContratos.tipoContrato}} no CONECTIVIDADE SOCIAL.

    </p>
    <br />
    <p class="text-justify">
        Perfil: {{infoContratos.desPerfil}}
    </p>
    <br />
    Serviços Disponíveis:
    <ul>
        <li *ngFor="let servico of infoContratos.servicos">{{servico}}</li>
    </ul>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 2ª - LEI GERAL DE PROTEÇÃO DE DADOS PESSOAIS (LGPD)</strong><br /><br />
        As atividades de tratamento de dados pessoais do presente contrato observam a boa-fé e os seguintes princípios:
        <br /> I - Finalidade: realização do tratamento para propósitos legítimos, específicos, explícitos e informados
        ao titular, sem possibilidade de tratamento posterior de forma incompatível com essas finalidades;
        <br /> II - Adequação: compatibilidade do tratamento com as finalidades informadas ao titular, de acordo com o
        contexto do tratamento;
        <br /> III - Necessidade: limitação do tratamento ao mínimo necessário para a realização de suas finalidades,
        com abrangência dos dados pertinentes, proporcionais e não excessivos em relação às finalidades do tratamento de
        dados;

    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 3ª - DAS DEFINIÇÕES</strong><br /><br />
        Para efeito deste contrato, considera-se:
        <br /> I - CONECTIVIDADE SOCIAL - Aplicativo que, através de acesso remoto, via Internet, disponibiliza serviços
        e informações ao CLIENTE. Marca registrada da CAIXA que identifica o conjunto de serviços e informações
        disponíveis através de conexão segura com o seu ambiente computacional. Ferramenta tecnológica associada à
        Internet que viabiliza a troca segura de informações entre as Instituições Financeiras;
        <br /> II - CONEXÃO - Forma de comunicação entre os computadores do CLIENTE e o ambiente computacional do
        CONECTIVIDADE SOCIAL;
        <br /> III - - Internet - Rede de computadores interligados em todo o mundo, que se utiliza de um mesmo
        protocolo (TCP/IP) e de serviços de forma a permitir que os computadores instalados em diversas regiões
        geográficas possam entrar em contato uns com os outros e trocar informações;
        <br /> IV - PROTOCOLO TCP/IP - (Transmission Control Protocol / Internetworking Protocol) - Protocolo de
        comunicação básico da Internet para interconectar redes cujos componentes podem usar sistemas operacionais
        distintos;
        <br /> V - PROVEDOR - Máquinas Servidoras que possibilitam, às máquinas clientes, o acesso à rede Internet;
        <br /> VI - SENHA - código secreto que possibilita o acesso ao aplicativo disponibilizado. É pessoal e
        intransferível, razão pela qual a CAIXA não se responsabiliza pelo seu uso indevido;
        <br /> VII - ASSINATURA ELETRÔNICA - é o mecanismo apto a permitir e legitimar a autorização de acesso ao
        serviço requerido; sempre combinada com a senha.
        <br /> VIII - CERTIFICADO DIGITAL - Identificação eletrônica mediante o uso de chave pública e privada,
        utilizada para atestar a identidade dos atores envolvidos na conexão;
        <br /> IX - Ambiente Computacional do CONECTIVIDADE SOCIAL - Computadores de pequeno e grande porte onde estão
        contidos os dados e as informações referentes aos produtos e serviços oferecidos pela CAIXA;
        <br /> X - EMPRESA RAIZ - Pessoa Jurídica que se encontra no primeiro nível na cadeia de procurações, sendo
        detentora originária dos poderes relacionados ao seu perfil registrado no CONECTVIDADE SOCIAL.
        <br /> XI - PODER - Serviço disponibilizado no CONECTVIDADE SOCIAL, que pode ser utilizado pela EMPRESA RAIZ ou
        repassado por ela a terceiros.
        <br /> XII - CADEIA HORIZONTAL - cadeia de procurações que se encontram no mesmo nível de outorga ou
        substabelecimento.
        <br /> XIII - CADEIA VERTICAL - cadeia de procurações concedidas a Pessoas Jurídicas ou Físicas, que se
        encontram em diferentes níveis de outorga ou substabelecimento, cujas validades são condicionadas à validade das
        procurações precedentes.
        <br /> XIV - OUTORGANTE - Pessoa Jurídica ou Física que transfere seus poderes a outrem, no todo ou em parte,
        com ou sem prerrogativa de substabelecimento, por meio de Procuração Eletrônica do CONECTIVIDADE SOCIAL.
        <br /> XV - OUTORGADO - Pessoa Jurídica ou Física que representa o Outorgante através de Procuração Eletrônica
        do CONECTIVIDADE SOCIAL.
        <br /> XVI - SUBSTABELECEDOR - Pessoa Jurídica ou Física que, tendo recebido poderes através de Procuração
        Eletrônica do CONECTIVIDADE SOCIAL com prerrogativa de substabelecimento, os transfere a outrem.
        <br /> XVII - SUBSTABELECIDO - Pessoa Jurídica ou Física que recebe poderes de um substabelecedor por meio de
        Procuração Eletrônica do CONECTIVIDADE SOCIAL.
        <br /> XVIII - SÍTIO - é um conjunto de páginas acessíveis através de um endereço na Internet.
        <br /> IXX - Firewall - é o nome dado ao dispositivo de rede de computadores que tem por objetivo aplicar uma
        política de segurança com o objetivo de evitar acessos nocivos ou não autorizados.

    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 4ª - DA UTILIZAÇÃO O CLIENTE</strong><br /><br />
        Deverá dispor de certificado digital válido, gerado no padrão ICP-Brasil por Autoridade Certificadora - AC
        credenciada pelo Instituto Brasileiro de Tecnologia da Informação - ITI, e da respectiva senha, de caráter
        sigiloso, pessoal e intransferível.
        <br />§ 1º - Quaisquer irregularidades verificadas quando da operacionalização do CONECTIVIDADE SOCIAL deverão
        ser comunicadas à CAIXA e, se for o caso, o CLIENTE deverá solicitar imediatamente a suspensão do serviço.
        <br /> § 2º - A CAIXA poderá, a qualquer tempo, suspender e cancelar o acesso ao CONECTIVIDADE SOCIAL, caso
        verifique, através dos seus sistemas de segurança, que as operações realizadas pelo CLIENTE estão ou possam vir
        a estar comprometidas pelo uso de programas adulterados ou maliciosos que ameacem a integridade, a
        confidencialidade ou a disponibilidade das informações contidas no sítio do CONECTIVIDADE SOCIAL, comunicando,
        posteriormente, ao CLIENTE.O Perfil Pessoa Jurídica Restrita abriga também todas as funcionalidades disponíveis
        para o Perfil Pessoa Jurídica Amplo não necessitando troca de perfil para atuar nas distintas funcionalidades.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 5ª - DAS OBRIGAÇÕES DA CAIXA</strong><br /><br />
        A CAIXA se obriga a:
        <br /> I - disponibilizar acesso aos serviços disponíveis no CONECTIVIDADE SOCIAL, a qualquer tempo, no ambiente
        do próprio cliente;
        <br /> II - prestar as informações necessárias ao CLIENTE sobre os procedimentos de instalação e configuração
        dos aplicativos disponibilizados;
        <br /> III - manter Central de Atendimento à disposição do CLIENTE, nos dias e horários definidos pela CAIXA,
        para consultas sobre questões técnicas relativas à instalação, configuração, navegação e acesso ao CONECTIVIDADE
        SOCIAL;
        <br /> IV - processar ou encaminhar para processamento junto à instituição destinatária as informações recebidas
        do CLIENTE pelo CONETIVIDADE SOCIAL, desde que estas estejam consistidas e atendam aos requisitos de segurança
        ou quaisquer outros que venham a ser definidos pela CAIXA.
        <br /> V - assumir eventuais danos e/ou prejuízos causados por seus empregados e/ou prepostos no caso destes
        divulgarem ou utilizarem indevidamente dados ou informações a que tiverem acesso em virtude do presente
        contrato.

    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 6ª - DAS OBRIGAÇÕES DO CLIENTE</strong><br /><br />
        O CLIENTE se obriga a:
        <br /> I - arcar com quaisquer despesas decorrentes dos serviços de telecomunicações, inclusive provedores de
        acesso à Internet, utilizados para conexão com o ambiente computacional do CONECTIVIDADE SOCIAL;
        <br /> II - fazer uso adequado da faculdade de outorga e substabelecimento de Procuração Eletrônica, a que alude
        a CLÁUSULA 9ª deste contrato;
        <br /> III - guardar sigilo de sua Senha, solicitando ou providenciando sua troca sempre que julgar necessário,
        bem como manter em lugar seguro seu Certificado Digital;
        <br /> IV - comunicar à CAIXA qualquer indício de irregularidade ou anormalidade apurada na utilização do
        CONECTIVIDADE SOCIAL;
        <br /> V - dispor, por seus próprios meios e iniciativas, de equipamentos e programas computacionais, além de
        todos os instrumentos necessários, compatíveis com a solução tecnológica do CONECTIVIDADE SOCIAL e suas
        atualizações, que possibilitem a sua participação nas consultas aos dados e acesso aos serviços do CONECTIVIDADE
        SOCIAL;
        <br /> VI - comprovar perante a CAIXA, no prazo e na forma estabelecidos por esta, sua condição de detentora de
        PERFIL {{infoContratos.tipoContrato}}, como forma de obter acesso aos serviços disponibilizados no CONECTIVIDADE
        SOCIAL vinculados ao seu perfil de registro;
        <br /> VII - solicitar o cancelamento de seu perfil {{infoContratos.tipoContrato}} ou alterar seu perfil, na
        forma estabelecida pela CAIXA, sempre que sua natureza jurídica ou suas atividades se tornem incompatíveis com o
        PERFIL {{infoContratos.tipoContrato}} previamente registrado no CONECTIVIDADE SOCIAL.
        <br /> VIII - assumir eventuais danos ou prejuízos causados à CAIXA ou a terceiros pelo uso indevido do
        CONETIVIDADE SOCIAL ou pela divulgação ou utilização indevida das informações a que o CLIENTE e seus
        substabelecidos tiverem acesso em virtude do presente contrato;
        <br /> IX - responsabilizar-se integralmente pelos atos por ele praticados e solidariamente pelos executados por
        seus substabelecidos;
        <br /> X - utilizar antivírus, firewall e demais programas sempre com versões atualizadas e registradas de
        acordo com a legislação vigente;
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 7ª - DAS RESPONSABILIDADES DO CLIENTE</strong><br /><br />
        É de inteira responsabilidade do CLIENTE toda e qualquer informação prestada no uso dos serviços disponíveis no
        CONECTIVIDADE SOCIAL, mediante a utilização de seu Certificado Digital e Senha.
        <br /> § 1º - Fornecer informações corretas e atualizadas, as quais, após atestada a autenticidade e
        consistência do Certificado Digital e senha utilizados, serão, para todos os efeitos legais, consideradas como
        prestadas pelo CLIENTE.
        <br /> § 2º - Usar adequadamente os serviços do CONECTIVIDADE SOCIAL. Comprovada sua utilização para fins
        ilícitos ou inadequados, sujeitar-se-á o CLIENTE às penalidades civis e penais cabíveis e à imediata suspensão
        ou revogação dos serviços.
        <br /> § 3º - Assumir inteira responsabilidade pela criação, extinção ou alteração de direitos ou deveres que
        venham a ocorrer em razão de informações incorretas, falsas, incompletas, adulteradas ou inconsistentes que
        sejam prestadas por ele, por seus outorgados ou por seus substabelecidos no CONECTIVIDADE SOCIAL, perante a
        CAIXA ou quaisquer outras entidades da Administração Pública direta ou indireta, ou ainda perante particulares
        que venham a ser prejudicados.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 8ª - DO DIREITO DE PROPRIEDADE</strong><br /><br />
        A marca CONECTIVIDADE SOCIAL, o aplicativo, o sítio do CONECTIVIDADE SOCIAL e as imagens associadas à respectiva
        solução tecnológica são de propriedade da CAIXA ECONÔMICA FEDERAL, sendo vedado ao CLIENTE, nos termos da
        legislação em vigor, por qualquer forma, utilizá-los para obter lucros ou benefícios, para si ou para outrem,
        decorrentes do direito de uso objeto deste contrato.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 9ª - DAS ATUALIZAÇÕES E MODIFICAÇÕES</strong><br /><br />
        A CAIXA, poderá agregar, retirar ou alterar os serviços e as formas de acesso ao CONECTIVIDADE SOCIAL, além de
        promover, a qualquer tempo, atualizações no aplicativo por meio de novas versões.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 10ª - DA UTILIZAÇÃO DO CONECTIVIDADE SOCIAL POR TERCEIROS</strong><br /><br />
        O CLIENTE poderá, mediante outorga ou substabelecimento de Procuração Eletrônica, repassar a terceiros os
        poderes eventualmente recebidos por outorga ou substabelecimento, se assim dispôs previamente o outorgante ou
        substabelecedor, observadas as regras de utilização desta prerrogativa definidas pela CAIXA.
        <br /> § 1º - A Procuração Eletrônica conferida pelo CLIENTE a um terceiro gera efeitos exclusivamente no âmbito
        do CONECTIVIDADE SOCIAL, podendo, todavia, ser aceita para outros processos que sejam disponibilizados pela
        CAIXA ou por outras entidades da Administração Pública direta ou indireta, exclusivamente em rotinas
        relacionadas às obrigações do CLIENTE junto a essas entidades e às informações transitadas pelo Conectividade
        Social.
        <br /> § 2º - O CLIENTE não poderá conceder outorga dos poderes disponíveis para o Perfil Pessoa Jurídica
        Restrita nem, em hipótese alguma, substabelecer além do 5º nível vertical.
        <br /> § 3º - As Procurações Eletrônicas têm validade de 12 meses a partir da data de emissão, devendo ser
        renovadas antes do seu vencimento a fim de não comprometer a continuidade dos serviços disponibilizados ao
        CLIENTE, a seus outorgados e a seus substabelecidos.
        <br /> § 4º - A validade da Procuração Eletrônica não está vinculada à validade do Certificado Digital, mas à
        validade das procurações na cadeia vertical superior e à validade do registro do CLIENTE e dos demais membros da
        cadeia de procurações no CONECTIVIDADE SOCIAL.
        <br /> § 5º - O CLIENTE somente poderá conceder Procuração Eletrônica a Pessoa Física que mantenha, com o mesmo
        empregador, espécie de vínculo empregatício passível de ser atestada pela CAIXA, por meio de seu próprio
        cadastro ou de outras informações que esta venha, a seu critério, entender mais adequadas.
        <br /> § 6º - No momento do substabelecimento de uma Procuração Eletrônica, o CLIENTE transfere um conjunto de
        poderes recebidos do outorgante ou substabelecedor a um terceiro, para este transacionar em nome do outorgante
        no CONECTIVIDADE SOCIAL, podendo conferir ao substabelecido o direito de substabelecer os poderes recebidos.
        <br /> § 7º - O CLIENTE ou seus procuradores Pessoa Física, estes desde que autorizados, poderão conceder
        Procuração Eletrônica a Pessoas Jurídicas; porém, estas não poderão repassar os poderes recebidos a outras
        Pessoas Jurídicas, ainda que o CLIENTE ou seus procuradores Pessoas Físicas tenham conferido ao substabelecido o
        direito de substabelecimento.
        <br /> § 8º - As transações efetuadas por um terceiro que tenha recebido uma Procuração Eletrônica do CLIENTE ou
        de seu procurador, quando este for autorizado a substabelecer poderes, gerarão os mesmos efeitos das transações
        efetuadas pelo próprio CLIENTE, recaindo sobre este a responsabilidade por tais transações, nos termos da
        CLÁUSULA 6ª e demais disposições deste contrato.
        <br /> § 9º - As procurações eletrônicas não poderão, em hipótese alguma, ser substabelecidas além do 5º nível
        vertical.
        <br /> § 10º - Cabe exclusivamente ao CLIENTE o controle do uso das procurações eletrônicas por ele ou por seus
        procuradores conferidas, podendo revogá-las a seu próprio critério e a qualquer tempo.
        <br /> § 11º - Ocorrendo a revogação ou expiração de uma procuração eletrônica, todas as procurações a esta
        vinculadas, na cadeia vertical inferior, serão igualmente revogados ou expirados pelo sistema.
        <br /> § 12º - Ocorrendo a revogação ou suspensão do Registro do CLIENTE, todas as outorgase os
        substabelecimentos concedidos serão igualmente revogados pelo sistema.
        <br /> § 13º - A CAIXA poderá revogar, de ofício, qualquer Procuração Eletrônica que venha a ser considerada
        irregular ou potencialmente lesiva ao CLIENTE, aos demais usuários do CONECTIVIDADE SOCIAL ou a quaisquer
        entidades da Administração Pública Direta ou Indireta, ou ainda que venha a estar em discordância com as normas
        e regras estabelecidas pela CAIXA, mesmo que em razão de fatos ou circunstâncias supervenientes à sua outorga ou
        substabelecimento.
        <br /> § 14º - As procurações eletrônicas podem, ainda, ser aditadas a qualquer tempo, acrescentando-se a elas
        novos poderes, porém esta ação não confere novo prazo de validade a tais procurações.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 11ª - DO PRAZO DE DURAÇÃO</strong><br /><br />
        As presentes disposições vigorarão a partir da data da aceitação pelo CLIENTE deste Instrumento de Contrato, por
        prazo indeterminado, até que seja denunciado ou revogado por uma das partes.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 12ª - DA DENÚNCIA</strong><br /><br />
        Será facultada às partes a denúncia do presente contrato, a qualquer tempo, mediante comunicação formal.
        <br />§ 1º - Constituirá causa de denúncia, independente de aviso ou interpelação, judicial ou extrajudicial,
        respondendo a parte que der causa à rescisão, pelos prejuízos causados à outra:
        <br /> I - o descumprimento de quaisquer das cláusulas contratuais;
        <br /> II - a prática dolosa de qualquer ação ou deliberada omissão do CLIENTE visando a obtenção de vantagens
        ilícitas por meio do CONECTIVIDADE SOCIAL.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 13ª - DO PREÇO DA PRESTAÇÃO DOS SERVIÇOS</strong><br /><br />
        Por liberalidade da CAIXA, não serão cobradas tarifas ao CLIENTE ou a seus procuradores pela prestação dos
        serviços que forem objeto do presente contrato.
        <br /> § 1º - A CAIXA pode a qualquer tempo vir a revogar tal liberalidade de isenção, passando a cobrar tarifa
        pela utilização de parte ou da totalidade dos serviços disponibilizados no CONECTIVIDADE SOCIAL, caso em que o
        CLIENTE será notificado, por meio de sua caixa postal no próprio CONECTIVIDADE SOCIAL, com antecedência mínima
        de 60 (sessenta) dias. Na mesma notificação, constarão os valores das tarifas eventualmente cobradas por serviço
        ou conjunto de serviços, a forma de apuração e de cobrança.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 14ª - DAS DISPOSIÇÕES GERAIS</strong><br />
        <br /> O CLIENTE, após manifestar o aceite aos termos, condições e respectivos anexos deste contrato, terá
        acesso à utilização da solução tecnológica CONECTIVIDADE SOCIAL.
    </p>
    <br />
    <p class="text-justify">
        <strong>CLÁUSULA 15ª - DO FORO</strong><br />
        <br />Para dirimir quaisquer questões decorrentes deste instrumento, as partes elegem, com privilégio sobre
        qualquer outro, o foro da Seção Judiciária da Justiça Federal do Distrito Federal - DF.
    </p>
    <br />
    <p class="text-justify">
        <strong><u>ANEXO 1- POLÍTICA PARA ACESSO AOS RECURSOS COMPUTACIONAIS DA CAIXA POR ENTIDADES
                EXTERNAS</u></strong>
    </p>
    <br />
    <p class="text-justify">
        <strong>1 – OBJETIVO</strong>
        <br /> 1.1 Informar às Entidades Externas, denominadas convenentes, as diretrizes, critérios e procedimentos que
        devem ser seguidos por seus empregados para os quais for solicitado acesso aos recursos computacionais da CAIXA,
        mediante Convênio firmado com a CAIXA ECONÔMICA FEDERAL.
    </p>
    <br />
    <p class="text-justify">
        <strong>2 - CRITÉRIOS GERAIS</strong>
        <br />2.1 O acesso à rede e aos sistemas corporativos da CAIXA, através de equipamentos operados fora de suas
        instalações físicas, por empregado de entidade externa que tenha firmado Convênio para acesso aos sistemas da
        CAIXA deve ser realizado atendendo as diretrizes contidas neste documento.
        <br />2.2 O empregado de Entidade Externa é denominado “usuário externo” para efeito de identificação junto à
        CAIXA como usuário autorizado a ter acesso aos seus recursos computacionais.

    </p>
    <br />
    <p class="text-justify">
        <strong>3 - RESPONSABILIDADES</strong>
        <br /><strong>3.1 - Da Entidade Externa Convenente</strong>
        <br />3.1.1 Dar ciência dessa Política aos empregados autorizados a ter acesso aos recursos computacionais da
        CAIXA, fazendo com que as responsabilidades e os procedimentos aqui descritos sejam cumpridos por esses
        empregados, arcando com as responsabilizações inerentes pelo não cumprimento.
    </p>
    <br />
    <p class="text-justify">
        <strong>3.2 - Do Usuário Externo</strong>
        <br /> 3.2.1 1 Estar ciente e cumprir os critérios e responsabilidades estabelecidas nesta Política, que lhe
        diga respeito.
        <br /> 3.2.2 Estar ciente de que a senha fornecida pela CAIXA para acesso aos recursos computacionais que lhe
        forem disponibilizados é uma informação de segurança que tem caráter <strong>pessoal e intransferível e requer
            sigilo absoluto</strong>.
        <br /> 3.2.3 <strong>A divulgação da senha é terminantemente proibida</strong>, estando o usuário externo
        sujeito a ser responsabilizado por danos decorrentes da sua divulgação e uso indevido e a aplicação das sanções
        descritas na cláusula quarta do Convênio.
        <br /> 3.2.4 Manter o sigilo da senha, respondendo pelo uso indevido, e pelo uso por terceiros.
        <br /> 3.2.5 Executar apenas as funções específicas que lhe foram concedidas pela autorização de acesso.
        <br /> 3.2.6 Usar os recursos e as informações para as quais lhe foi concedido acesso em estrita observância a
        abrangência atribuída pelo gestor da informação da CAIXA e às cláusulas constantes no Convênio firmado com a
        CAIXA pela Entidade Externa a que pertence, estando ciente do grau de sigilo atribuído à informação
        disponibilizada.
    </p>
    <br />
    <p class="text-justify">
        <strong><u>ANEXO 2-TERMO DE RESPONSABILIDADE DE USUÁRIO EXTERNO</u></strong>
    </p>
    <br />
    <p class="text-justify">
        Comprometo-me a fazer uso dos recursos e das informações que me forem disponibilizadas, por meio do acesso
        concedido pela CAIXA, em estrita observância a sua Política de Segurança da informação e aos seus normativos que
        tratem dos recursos computacionais que me forem autorizados.
    </p>
    <br />
    <p class="text-justify">
        <strong><u> ANEXO3-TERMO DE RESPONSABILIDADE DE SEGURANÇA DA INFORMAÇÃO</u></strong>
    </p>
    <br />
    <p class="text-justify">
        Declaro ter permissão de acesso às informações da CAIXA, ou sob sua responsabilidade, recebidas do gestor
        responsável, necessárias ao desempenho das atividades executadas para a empresa à qual sou vinculado e
        comprometo-me a cumprir o disposto nos itens a seguir:

        <br /> 1. Conhecer e cumprir, rigorosamente, a Política de Segurança e Informação – PO007 e demais normas e
        procedimentos da CAIXA relativos à segurança da informação;
        <br /> 2. Estar ciente de que os acessos aos quais se referem o presente Termo foram concedidos para uso
        exclusivo nas atividades a que se destinam;
        <br /> 3. Não utilizar meus acessos para visualizar informações ou dados desnecessários ao exercício de minhas
        atividades;
        <br /> 4. Não utilizar meus acessos para copiar ou remover recursos computacionais, informação de propriedade da
        CAIXA ou por ela administrada, sem autorização para esse fim;
        <br /> 5. Não utilizar meus acessos para interferir em serviços, provocando, por exemplo, congestionamento,
        alteração, lentidão ou interrupção do tráfego da rede CAIXA;
        <br /> 6. Não utilizar os recursos e acessos disponibilizados pela CAIXA para tratar de assuntos pessoais,
        criticar a CAIXA e/ou seus empregados, ou em atividades ilegais como difamação, discriminação, obscenidade,
        pornografia, ameaça, roubo, tentativa de acesso desautorizado a dados ou tentativa de burlar medidas de
        segurança em sistemas, interceptação de mensagens eletrônicas e violação de direitos autorais;
        <br /> 7. Respeitar os direitos de propriedade, instalando e/ou utilizando somente recursos tecnológicos
        autorizados e com as respectivas licenças de uso válidas;
        <br /> 8. Não revelar fato ou informação de que tenha ciência em razão das atividades desempenhadas para a
        empresa, à qual sou vinculado;
        <br /> 9. Comunicar ao representante da empresa vinculada, qualquer suspeita ou evidência de transgressão às
        normas em vigor, principalmente para os casos em que ficar comprovado o comprometimento de informação
        corporativa da CAIXA ou sob sua responsabilidade, evitando que a imagem da CAIXA seja colocada em risco junto ao
        seu público interno e externo.

        <br /><br />Estou ciente de que:
        <br />• a CAIXA se reserva o direito de monitorar a utilização dos ativos de informação disponibilizados aos
        usuários, para assegurar o fiel cumprimento das orientações contidas na PO007;
        <br />• as responsabilidades quanto à segurança da informação, para as informações obtidas em virtude das
        atividades executadas;
        <br />• o descumprimento de qualquer item deste Termo pode acarretar a aplicação das sanções citadas, e, ainda,
        nos demais processos legais e responsabilidades civil e penal cabíveis;

        <br /><br />OBS.: A PO007 (Política de Segurança e Informação) está disponível publicamente no site da CAIXA, no
        endereço <a href="www.caixa.gov.br">caixa.gov</a>, clique na aba “Downloads”, item “Governança Corporativa”, no
        link “Política de Segurança e Informação”, ou acessado diretamente pelo endereço <a
            href="https://www.caixa.gov.br/Downloads/caixa-governanca/politica-seguranca-informacao.pdf">política de
            segurança da informação</a>.
    </p>
    <br />
</div>